(function () {
    'use strict';

    var container;
    var duration = 5; //секунд

    init();

    /**
     * Инициализация
     *
     */
    function init() {
        container = document.querySelector('.js-noty');
        if (!container) {
            return;
        }

        onShow();
    }

    function onShow() {
        window.noty = function (params) {
            container.classList.remove('is-show');
            container.classList.remove('is-error');
            container.classList.remove('is-success');

            container.classList.add('is-' + params.type);
            container.innerHTML = params.text;

            setTimeout(function () {
                container.classList.add('is-show');
            }, 100);
        }
    }


})();

